import { render } from "./DisplayAddress.vue?vue&type=template&id=54abd3eb"
import script from "./DisplayAddress.vue?vue&type=script&lang=js"
export * from "./DisplayAddress.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__